import { render, staticRenderFns } from "./SimpleFiltersCard.vue?vue&type=template&id=ab2f8a9a&scoped=true"
import script from "./SimpleFiltersCard.vue?vue&type=script&lang=ts"
export * from "./SimpleFiltersCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2f8a9a",
  null
  
)

export default component.exports